import {helpers} from '../common/helpers';
import {sliders} from './sliders';
import SimpleScrollbar from '../vendor/simple-scrollbar';

// new instance for each button, maybe refactor later

export class ButtonsBehavior {
	constructor($button) {
		let self = this;

		this.isHovered = false;
		this.animationPlan = '';
		this.animationStatus = 'idle';

		this.$button = $button;
		this.$text = $button.children('span:not(.button-shim)');
		this.$text1 = $button.children('span:not(.button-shim)').clone().appendTo($button).addClass('helper-cont');
		this.$shim = $button.children('.button-shim');

		this.$text.addClass('main-cont');
	}

	remove() {
		this.$text1.remove();
	}
}

$('.button, .js-hover-btn').each((i, elem) => {
	let hoverBehav = new ButtonsBehavior($(elem));
});

window.setModalEvents = function(elm){

	// dropdown in props modal
	elm.on('click', '.props-more__button', (e) => {
		let $parent = $(e.currentTarget).closest('.props-more');
		let $curContainer = $(e.currentTarget).siblings('.props-more__content');
		let height = $curContainer[0].scrollHeight;

		if (!$parent.hasClass('is-opened')) {
			$curContainer.css('height', height);
		} else {
			$curContainer.removeAttr('style');
		}

		$parent.toggleClass('is-opened');
	});

};

window.setModalEvents( $('body') );

// set body class
if ($('.park-futuro').length) {
	$('body').addClass('page-park park-futuro');
	$('.form-success__park').text('Futuro Park');
}

if ($('.park-avenue').length) {
	$('body').addClass('page-park park-avenue');
	$('.form-success__park').text('Park Avenue');
}

if ($('.park-fonte').length) {
	$('body').addClass('page-park park-fonte');
	$('.form-success__park').text('Park Fonte');
}

// set hero slider buttons position
function setHeroControls() {
	if (!$('.hero__controls').length) {
		return;
	}

	$('.hero__controls').css('padding-top', $('.hero-item:not(.is-hidden)').find('.hero__title').offset().top);
}

$(window).on('resize', setHeroControls);

// set menu icon position
function setMenuIconPos() {
	if (!$('.menu-icon').length) {
		return;
	}

	let height = $('.menu-icon').height();
	let winHeight = $(window).height();

	$('.menu-icon').css('bottom', (winHeight - height) / 2);
}

setMenuIconPos();
$(window).on('resize', setMenuIconPos);

// scroll in progress dropdowns
$('.progress-select__dropdown').each((i, elem) => {
	SimpleScrollbar.initEl(elem);
});

// contacts cards hover
$('.contacts-social__item').each((k, elem) => {
	let t = $(elem);

	t.on('mousemove', (e) => {
		let elemWidth = t.outerWidth();
		let elemHeight = t.outerHeight();
		let elemOffsetLeft = t.offset().left - $(window).scrollLeft();
		let elemOffsetTop = t.offset().top - $(window).scrollTop();
		let mouseX = (e.clientX - elemOffsetLeft) / elemWidth;
		let mouseY = (e.clientY - elemOffsetTop) / elemHeight;
		let c = 2 * (mouseY - 0.5);
		let f = (5 - 10 * mouseX).toFixed(2);
		let d = ((10 * mouseY - 5).toFixed(2), 10 * c);

		TweenLite.to(t, 0.4, {
			scale: 1.02,
			rotationY: f,
			y: d,
		});
	});

	t.on('mouseleave', (e) => {
		TweenLite.to(t, 0.4, {
			scale: 1,
			rotationX: 0,
			rotationY: 0,
			y: 0,
		});
	});
});

// show hero on load
function showFirstScreen() {
	let $header = $('.header');
	let $heroShim = $('.hero__shim');
	let $heroControls = $('.hero__controls');

	let $firstSlide = $('.hero-item').eq(0);
	let $image = $firstSlide.find('.hero-item__image');
	let $imageShim = $firstSlide.find('.hero-item__image__shim');
	let $title = $firstSlide.find('.hero__title');
	let $desc = $firstSlide.find('.hero__desc');
	let $button = $firstSlide.find('.hero__btn');
	let $stats = $firstSlide.find('.hero__stats');
	let $scrollBtn = $('.hero__scrolldown');

	TweenMax.set([
		$title,
		$desc,
		$button,
	], {
		y: $(window).height() / 2,
	});

	function showAnim() {
		if ($('.hero').hasClass('hero-contacts')) {
			TweenMax.set([
				$title,
				$desc,
				$button,
			], {
				y: 0,
				opacity: 1,
			});

			TweenMax.set($image, {
				y: 0,
			});
			TweenMax.set($heroShim, {
				scaleY: 0,
			});
			TweenMax.set($imageShim, {
				opacity: 1,
			});

			new TimelineMax({
				onComplete() {
					helpers.isHeroShown = true;
					$(document).trigger('hero.isShown');

					$('.callback-button').removeClass('is-opac-hidden');
				},
			})
				.to($header, 0.5, {
					y: 0,
					ease: 'default',
					clearProps: 'transform',
					onComplete() {
						$header.addClass('is-shown');
					},
				});

			return;
		}

		new TimelineMax({
			onComplete() {
				helpers.isHeroShown = true;
				$(document).trigger('hero.isShown');

				if (sliders.heroSlider) {
					sliders.heroSlider.startAutoplay();
				}

				$('.callback-button').removeClass('is-opac-hidden');
			},
		})
			.to($image, 1, {
				y: 0,
				ease: 'default',
			})
			.to($heroShim, 0.7, {
				scaleY: 0,
				ease: 'default',
			}, '-=0.7')
			.to($imageShim, 1, {
				opacity: 1,
				ease: 'default',
			})
			.to($title, 0.8, {
				opacity: 1,
				y: 0,
				ease: 'default',
				onComplete() {
					setHeroControls();
				},
			}, '-=1.3')
			.to($desc, 0.5, {
				opacity: 1,
				y: 0,
				ease: 'default',
			}, '-=0.8')
			.to($button, 0.6, {
				opacity: 1,
				y: 0,
				ease: 'default',
			}, '-=0.7')
			.to($header, 0.5, {
				y: 0,
				ease: 'default',
				clearProps: 'transform',
				onComplete() {
					$header.addClass('is-shown');
				},
			}, '-=0.3')
			.to($stats, 0.5, {
				y: 0,
				ease: 'default',
			}, '-=0.5')
			.to($scrollBtn, 0.5, {
				y: 0,
				ease: 'default',
			}, '-=0.5')
			.to($heroControls, 0.5, {
				x: 0,
				ease: 'default',
			}, '-=0.5');
	}

	let img = new Image();

	img.onload = () => {
		showAnim();
	};

	img.src = $image.attr('data-preload');
}

function listenForLoader() {
	var listenInterval = setInterval(function() {
		if (window.loaderShown) {
			showFirstScreen();
			clearInterval(listenInterval);
		}
	}, 50);
}
listenForLoader();

function resizeBgVideo() {
	if ($('.hero-item__image__inner video').length) {
		helpers.calc_bg_object(
			$('.hero-item__image__inner video')[0],
			$('.hero')[0],
			$('.hero-item__image__inner video').data('width'),
			$('.hero-item__image__inner video').data('height')
		);
	}

	if ($('.call__bg video').length) {
		helpers.calc_bg_object(
			$('.call__bg video')[0],
			$('.call__bg')[0],
			$('.call__bg video').data('width'),
			$('.call__bg video').data('height')
		);
	}
}

$(window).on('resize', () => {
	resizeBgVideo();
})

resizeBgVideo();
